import { Field, Select } from 'app-ui/primitives/input';
type ReferenceSelectProps = {
  label: string;
  value: string;
  options: { value: string; label: string }[];
  onChange: (selection: string) => void;
  disabled?: boolean;
};
export const ReferenceSelect = ({
  label,
  value,
  options,
  onChange,
  disabled,
}: ReferenceSelectProps) => (
  <Field.Root>
    <Field.Label>{label}</Field.Label>
    <Select.Root
      items={options}
      value={value}
      disabled={disabled}
      onValueChange={(selection) => {
        if (selection !== null) onChange(selection);
      }}
    >
      <Select.Trigger aria-label={label}>
        <Select.Value />
      </Select.Trigger>
      <Select.Popup>
        {options.map((option) => (
          <Select.Item key={option.value} value={option.value}>
            {option.label}
          </Select.Item>
        ))}
      </Select.Popup>
    </Select.Root>
  </Field.Root>
);
